module.exports = __webpack_public_path__ + "static/media/business.28bfdd0b.svg";